import { locationIdFormat } from "@redotech/redo-inventory-id";
import * as zExt from "@redotech/rpc/ext";
import { privacy } from "@redotech/schema-privacy";
import * as z from "zod";
import { DateFromDateOrIsoStringSchema } from "./date-schema";

const RedoFulfillmentToteSchema_ = z
  .object({
    _id: zExt.objectId().meta({ privacy: privacy.id.internal }),
    createdAt: DateFromDateOrIsoStringSchema.meta({
      privacy: privacy.timestamp,
    }),
    updatedAt: DateFromDateOrIsoStringSchema.meta({
      privacy: privacy.timestamp,
    }),
    team: zExt.objectId().meta({ privacy: privacy.id.internal }),
    name: z.string().meta({ privacy: privacy.resourceLabel }),
    barcode: z.string().meta({ privacy: privacy.id.internal }),
    barcodeUrl: z.string().meta({ privacy: privacy.privateUrl }).nullish(),
    pickSessionId: z.string().meta({ privacy: privacy.id.internal }).nullish(),
    toteGroupId: zExt
      .objectId()
      .meta({ privacy: privacy.id.internal })
      .nullish(),
    locationId: locationIdFormat.schema
      .meta({ privacy: privacy.id.internal })
      .nullish(),
  })
  .meta({ privacy: privacy.structured });
export const RedoFulfillmentToteSchema: z.ZodType<RedoFulfillmentTote> =
  RedoFulfillmentToteSchema_;

export interface RedoFulfillmentTote extends z.infer<
  typeof RedoFulfillmentToteSchema_
> {}
